import { createFileRoute } from '@tanstack/react-router'
import StaffDetailView from './-components/staff-detail-view'

export const Route = createFileRoute('/manager/_layout/employee-performance/$employeeId')({
  component: Component,
})

function Component() {
  const { employeeId } = Route.useParams()
  
  return <StaffDetailView staffId={employeeId} />
}
